<template>
    <div>
        <div v-if="preparingPDF" ref="pdfContent" style="padding: 20px; background: white; font-size: 12px;">
            <h3 class="text-center mb-4" style="color: black;">Key Handover</h3>

            <div class="mb-3">
                <table style="width: 100%; border-collapse: collapse; color: black;">
                    <tr>
                        <td><strong>Unit No:</strong> {{ `${propertyData.address_no? propertyData.address_no: ''}` }}</td>
                        <td><strong>Date of Record:</strong> {{ form.date? formatDate(form.date): '' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Residence:</strong> {{ propertyData.place_name ? propertyData.place_name[currentLocale] : '' }}</td>
                        <td><strong>Buiding/Floor:</strong> {{ `${propertyData.buildiing? `Building ${propertyData.buildiing}`: ''} ${propertyData.floors? propertyData.floors: ''}` }}</td>
                    </tr>
                </table>
            </div>

            <p style="color: black;">{{ `The unit owner hereby acknowledges receipt of the following keys to the premises` }}</p>

            <h5 style="color: black;">Handover Items</h5>
            <table class="table table-bordered" style="text-align: center; color: black;">
                <thead>
                <tr>
                    <th>No</th>
                    <th>Item/Location</th>
                    <th>Key No.</th>
                    <th>Total</th>
                    <th>Check-in</th>
                    <th>Check-out</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in form.handoverItems" :key="index">
                        <td>{{ index+1 }}</td>
                        <td>{{ item.location }}</td>
                        <td>{{ item.number }}</td>
                        <td>{{ item.total }}</td>
                        <td>{{ '' }}</td>
                        <td>{{ '' }}</td>
                    </tr>
                </tbody>
            </table>
            <div v-if="form.handoverItemsImage" style="margin-top: 8px;">
                <p style="margin: 0 0 6px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; color: #777;">Photo</p>
                <img :src="form.handoverItemsImage" style="width: 100%; max-height: 400px; object-fit: contain; border-radius: 6px; border: 1px solid #ddd;" />
            </div>

            <p style="color: black;"><strong>{{ 'Other: ' }}</strong>{{ form.notes? form.notes: '' }}</p>
            <p>{{ `Include in the lease of unit and to be returned upon departure of unit.` }}</p>

            <div style="border: 1px solid #ececec; border-radius: 8px; overflow: hidden; margin-bottom: 16px; page-break-inside: avoid;">
                <div style="background: #f5f5f5; padding: 10px 16px; border-bottom: 1px solid #ececec;">
                    <strong style="color: #555; font-size: 13px;">&#9889; Electricity Meter</strong>
                </div>
                <div style="padding: 14px 16px; display: flex; gap: 20px;">
                    <div style="flex: 1;">
                        <p style="margin: 0 0 8px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; color: #28c76f;">&#9679; Check-in</p>
                        <table style="width: 100%; border-collapse: collapse; color: black; font-size: 12px;">
                            <tr>
                                <td style="padding: 4px 4px 4px 0; color: #777;">Record</td>
                                <td style="padding: 4px; font-weight: 600;">{{ form.electricity.arrivalRecord? form.electricity.arrivalRecord: '' }}</td>
                                <td style="padding: 4px 4px 4px 12px; color: #777;">Date</td>
                                <td style="padding: 4px; font-weight: 600;">{{ form.electricity.arrivalDate? formatDate(form.electricity.arrivalDate): '' }}</td>
                            </tr>
                        </table>
                        <div v-if="form.electricity.arrivalImage" style="margin-top: 8px;">
                            <img :src="form.electricity.arrivalImage" style="width: 120px; height: 120px; object-fit: cover; border-radius: 6px; border: 1px solid #ddd;" />
                        </div>
                    </div>
                    <div style="flex: 1; border-left: 1px solid #f1f0f5; padding-left: 20px;">
                        <p style="margin: 0 0 8px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; color: #ea5455;">&#9679; Check-out</p>
                        <table style="width: 100%; border-collapse: collapse; color: black; font-size: 12px;">
                            <tr>
                                <td style="padding: 4px 4px 4px 0; color: #777;">Record</td>
                                <td style="padding: 4px; font-weight: 600;">{{ form.electricity.departureRecord? form.electricity.departureRecord: '' }}</td>
                                <td style="padding: 4px 4px 4px 12px; color: #777;">Date</td>
                                <td style="padding: 4px; font-weight: 600;">{{ form.electricity.departureDate? formatDate(form.electricity.departureDate): '' }}</td>
                            </tr>
                        </table>
                        <div v-if="form.electricity.departureImage" style="margin-top: 8px;">
                            <img :src="form.electricity.departureImage" style="width: 120px; height: 120px; object-fit: cover; border-radius: 6px; border: 1px solid #ddd;" />
                        </div>
                    </div>
                </div>
            </div>

            <div style="border: 1px solid #ececec; border-radius: 8px; overflow: hidden; margin-bottom: 16px; page-break-inside: avoid;">
                <div style="background: #f5f5f5; padding: 10px 16px; border-bottom: 1px solid #ececec;">
                    <strong style="color: #555; font-size: 13px;">&#128167; Water Meter</strong>
                </div>
                <div style="padding: 14px 16px; display: flex; gap: 20px;">
                    <div style="flex: 1;">
                        <p style="margin: 0 0 8px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; color: #28c76f;">&#9679; Check-in</p>
                        <table style="width: 100%; border-collapse: collapse; color: black; font-size: 12px;">
                            <tr>
                                <td style="padding: 4px 4px 4px 0; color: #777;">Record</td>
                                <td style="padding: 4px; font-weight: 600;">{{ form.water.arrivalRecord? form.water.arrivalRecord: '' }}</td>
                                <td style="padding: 4px 4px 4px 12px; color: #777;">Date</td>
                                <td style="padding: 4px; font-weight: 600;">{{ form.water.arrivalDate? formatDate(form.water.arrivalDate): '' }}</td>
                            </tr>
                        </table>
                        <div v-if="form.water.arrivalImage" style="margin-top: 8px;">
                            <img :src="form.water.arrivalImage" style="width: 120px; height: 120px; object-fit: cover; border-radius: 6px; border: 1px solid #ddd;" />
                        </div>
                    </div>
                    <div style="flex: 1; border-left: 1px solid #f1f0f5; padding-left: 20px;">
                        <p style="margin: 0 0 8px; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; color: #ea5455;">&#9679; Check-out</p>
                        <table style="width: 100%; border-collapse: collapse; color: black; font-size: 12px;">
                            <tr>
                                <td style="padding: 4px 4px 4px 0; color: #777;">Record</td>
                                <td style="padding: 4px; font-weight: 600;">{{ form.water.departureRecord? form.water.departureRecord: '' }}</td>
                                <td style="padding: 4px 4px 4px 12px; color: #777;">Date</td>
                                <td style="padding: 4px; font-weight: 600;">{{ form.water.departureDate? formatDate(form.water.departureDate): '' }}</td>
                            </tr>
                        </table>
                        <div v-if="form.water.departureImage" style="margin-top: 8px;">
                            <img :src="form.water.departureImage" style="width: 120px; height: 120px; object-fit: cover; border-radius: 6px; border: 1px solid #ddd;" />
                        </div>
                    </div>
                </div>
            </div>

            <div style="page-break-inside: avoid;">
                <p style="color: black;">{{ `** To pay on his/her own bills for the electricity and water supply bills.` }}</p>
                <div class="mt-5 d-flex justify-content-between" style="color: black;">
                    <div>
                        <p style="text-align: center;">_______________________</p>
                        <p style="text-align: center;">Lessor</p>
                        <p style="text-align: center;">[<span style="display: inline-block; min-width: 180px;">{{ form.lessor ? form.lessor : '' }}</span>]</p>
                    </div>
                    <div>
                        <p style="text-align: center;">_______________________</p>
                        <p style="text-align: center;">Lessee</p>
                        <p style="text-align: center;">[<span style="display: inline-block; min-width: 180px;">{{ form.lessee ? form.lessee : '' }}</span>]</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- ── Page ── -->
        <div class="kh-page">

            <!-- Top bar -->
            <div class="kh-topbar">
                <div class="kh-topbar-left">
                    <span class="kh-topbar-icon">&#128273;</span>
                    <span class="kh-topbar-title">Key Handover</span>
                </div>
                <div class="kh-topbar-actions">
                    <router-link class="kh-btn kh-btn-outline" :to="{ name: 'inventory-add', query: { propertyId: property_id } }">&#8592; Back</router-link>
                    <button type="button" class="kh-btn kh-btn-outline" v-if="handoverData && handoverData.id" @click="exportPDF">&#11015; Download PDF</button>
                    <button type="button" class="kh-btn kh-btn-primary" @click="submitForm">&#10003; Save</button>
                </div>
            </div>

            <form @submit.prevent="submitForm">

                <!-- ── Section: Parties & Date ── -->
                <div class="kh-card">
                    <div class="kh-card-header">
                        <span class="kh-card-icon">&#128100;</span> Parties &amp; Date
                    </div>
                    <div class="kh-card-body">
                        <div class="kh-grid-3">
                            <div class="kh-field">
                                <label class="kh-label">Lessor</label>
                                <input id="lessor" v-model="form.lessor" class="kh-input" placeholder="Lessor name" />
                            </div>
                            <div class="kh-field">
                                <label class="kh-label">Lessee</label>
                                <input id="lessee" v-model="form.lessee" class="kh-input" placeholder="Lessee name" />
                            </div>
                            <div class="kh-field">
                                <label class="kh-label">Date of Record</label>
                                <input type="date" id="recordDate" v-model="form.date" class="kh-input" />
                                <small v-if="handoverData && handoverData.updated_at" class="kh-last-updated">
                                    Last updated: {{ formatDateTime(handoverData.updated_at) }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ── Section: Meters ── -->
                <div class="kh-grid-2-cols">

                    <!-- Electricity -->
                    <div class="kh-card">
                        <div class="kh-card-header kh-card-header-warning">
                            <span>&#9889;</span> Electricity Meter
                        </div>
                        <div class="kh-card-body">
                            <div class="kh-meter-section">
                                <div class="kh-meter-label">
                                    <span class="kh-meter-dot kh-dot-in"></span>
                                    <span class="kh-meter-label-text kh-text-in">Check-in</span>
                                </div>
                                <div class="kh-meter-fields">
                                    <div class="kh-field kh-field-inline">
                                        <label class="kh-label">Record <span class="kh-optional">optional</span></label>
                                        <input v-model="form.electricity.arrivalRecord" class="kh-input" />
                                    </div>
                                    <div class="kh-field kh-field-inline">
                                        <label class="kh-label">Date <span class="kh-optional">optional</span></label>
                                        <input type="date" v-model="form.electricity.arrivalDate" class="kh-input" />
                                    </div>
                                    <div class="kh-field kh-photo-field">
                                        <label class="kh-label kh-label-hidden">Photo</label>
                                        <div class="kh-photo-thumb" v-if="form.electricity.arrivalImage">
                                            <img :src="form.electricity.arrivalImage" @click="openImagePreview(form.electricity.arrivalImage)" />
                                            <button type="button" class="kh-photo-remove" @click="removeMeterImage('electricity', 'arrival')" title="Remove photo">&#215;</button>
                                        </div>
                                        <label class="kh-photo-icon-btn" v-else title="Add photo">
                                            <input type="file" accept="image/*" class="kh-photo-input" @change="onMeterImageChange($event, 'electricity', 'arrival')" />
                                            <span>&#128247;</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="kh-meter-section">
                                <div class="kh-meter-label">
                                    <span class="kh-meter-dot kh-dot-out"></span>
                                    <span class="kh-meter-label-text kh-text-out">Check-out</span>
                                </div>
                                <div class="kh-meter-fields">
                                    <div class="kh-field kh-field-inline">
                                        <label class="kh-label">Record <span class="kh-optional">optional</span></label>
                                        <input v-model="form.electricity.departureRecord" class="kh-input" />
                                    </div>
                                    <div class="kh-field kh-field-inline">
                                        <label class="kh-label">Date <span class="kh-optional">optional</span></label>
                                        <input type="date" v-model="form.electricity.departureDate" class="kh-input" />
                                    </div>
                                    <div class="kh-field kh-photo-field">
                                        <label class="kh-label kh-label-hidden">Photo</label>
                                        <div class="kh-photo-thumb" v-if="form.electricity.departureImage">
                                            <img :src="form.electricity.departureImage" @click="openImagePreview(form.electricity.departureImage)" />
                                            <button type="button" class="kh-photo-remove" @click="removeMeterImage('electricity', 'departure')" title="Remove photo">&#215;</button>
                                        </div>
                                        <label class="kh-photo-icon-btn" v-else title="Add photo">
                                            <input type="file" accept="image/*" class="kh-photo-input" @change="onMeterImageChange($event, 'electricity', 'departure')" />
                                            <span>&#128247;</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Water -->
                    <div class="kh-card">
                        <div class="kh-card-header kh-card-header-info">
                            <span>&#128167;</span> Water Meter
                        </div>
                        <div class="kh-card-body">
                            <div class="kh-meter-section">
                                <div class="kh-meter-label">
                                    <span class="kh-meter-dot kh-dot-in"></span>
                                    <span class="kh-meter-label-text kh-text-in">Check-in</span>
                                </div>
                                <div class="kh-meter-fields">
                                    <div class="kh-field kh-field-inline">
                                        <label class="kh-label">Record <span class="kh-optional">optional</span></label>
                                        <input v-model="form.water.arrivalRecord" class="kh-input" />
                                    </div>
                                    <div class="kh-field kh-field-inline">
                                        <label class="kh-label">Date <span class="kh-optional">optional</span></label>
                                        <input type="date" v-model="form.water.arrivalDate" class="kh-input" />
                                    </div>
                                    <div class="kh-field kh-photo-field">
                                        <label class="kh-label kh-label-hidden">Photo</label>
                                        <div class="kh-photo-thumb" v-if="form.water.arrivalImage">
                                            <img :src="form.water.arrivalImage" @click="openImagePreview(form.water.arrivalImage)" />
                                            <button type="button" class="kh-photo-remove" @click="removeMeterImage('water', 'arrival')" title="Remove photo">&#215;</button>
                                        </div>
                                        <label class="kh-photo-icon-btn" v-else title="Add photo">
                                            <input type="file" accept="image/*" class="kh-photo-input" @change="onMeterImageChange($event, 'water', 'arrival')" />
                                            <span>&#128247;</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="kh-meter-section">
                                <div class="kh-meter-label">
                                    <span class="kh-meter-dot kh-dot-out"></span>
                                    <span class="kh-meter-label-text kh-text-out">Check-out</span>
                                </div>
                                <div class="kh-meter-fields">
                                    <div class="kh-field kh-field-inline">
                                        <label class="kh-label">Record <span class="kh-optional">optional</span></label>
                                        <input v-model="form.water.departureRecord" class="kh-input" />
                                    </div>
                                    <div class="kh-field kh-field-inline">
                                        <label class="kh-label">Date <span class="kh-optional">optional</span></label>
                                        <input type="date" v-model="form.water.departureDate" class="kh-input" />
                                    </div>
                                    <div class="kh-field kh-photo-field">
                                        <label class="kh-label kh-label-hidden">Photo</label>
                                        <div class="kh-photo-thumb" v-if="form.water.departureImage">
                                            <img :src="form.water.departureImage" @click="openImagePreview(form.water.departureImage)" />
                                            <button type="button" class="kh-photo-remove" @click="removeMeterImage('water', 'departure')" title="Remove photo">&#215;</button>
                                        </div>
                                        <label class="kh-photo-icon-btn" v-else title="Add photo">
                                            <input type="file" accept="image/*" class="kh-photo-input" @change="onMeterImageChange($event, 'water', 'departure')" />
                                            <span>&#128247;</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ── Section: Handover Items ── -->
                <div class="kh-card">
                    <div class="kh-card-header">
                        <span>&#128218;</span> Handover Items
                        <span class="kh-count-badge">{{ form.handoverItems.length }}</span>
                    </div>
                    <div class="kh-card-body">
                        <!-- Shared photo for all handover items -->
                        <div class="kh-field kh-items-photo-field">
                            <label class="kh-label">Photo</label>
                            <div class="kh-photo-thumb kh-photo-thumb-lg" v-if="form.handoverItemsImage">
                                <img :src="form.handoverItemsImage" @click="openImagePreview(form.handoverItemsImage)" />
                                <button type="button" class="kh-photo-remove" @click="removeHandoverItemsImage" title="Remove photo">&#215;</button>
                            </div>
                            <label class="kh-photo-icon-btn kh-photo-icon-btn-lg" v-else title="Add photo">
                                <input type="file" accept="image/*" class="kh-photo-input" @change="onHandoverItemsImageChange" />
                                <span>&#128247;</span>
                            </label>
                        </div>

                        <!-- Add form -->
                        <div class="kh-add-form">
                            <div class="kh-add-location">
                                <label class="kh-label">Item / Location</label>
                                <input v-model="newItem.location" class="kh-input" />
                            </div>
                            <div class="kh-add-sub">
                                <label class="kh-label">Key No.</label>
                                <input v-model="newItem.number" class="kh-input" />
                            </div>
                            <div class="kh-add-sub">
                                <label class="kh-label">Total</label>
                                <input v-model="newItem.total" class="kh-input" type="number" min="0" />
                            </div>
                            <button type="button" class="kh-btn kh-btn-primary kh-add-btn" @click="addHandoverItem">+ Add</button>
                        </div>

                        <!-- Items table -->
                        <div class="kh-table-wrap" v-if="form.handoverItems.length">
                            <table class="kh-table">
                                <thead>
                                    <tr>
                                        <th class="kh-th" style="width: 30px;"></th>
                                        <th class="kh-th" style="width: 40px;">#</th>
                                        <th class="kh-th">Item / Location</th>
                                        <th class="kh-th" style="width: 120px;">Key No.</th>
                                        <th class="kh-th" style="width: 80px;">Total</th>
                                        <th class="kh-th" style="width: 60px;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, index) in form.handoverItems"
                                        :key="index"
                                        :class="[index % 2 === 1 ? 'kh-tr-stripe' : '', dragIndex === index ? 'kh-tr-dragging' : '', dragOverIndex === index ? 'kh-tr-dragover' : '']"
                                        @dragover="onDragOver(index, $event)"
                                        @drop="onDrop(index, $event)"
                                    >
                                        <td class="kh-td kh-td-center kh-td-drag" data-label="">
                                            <span
                                                class="kh-drag-handle"
                                                draggable="true"
                                                title="Drag to reorder"
                                                @dragstart="onDragStart(index, $event)"
                                                @dragend="onDragEnd"
                                            >&#8942;&#8942;</span>
                                        </td>
                                        <td class="kh-td kh-td-center" data-label="#">{{ index + 1 }}</td>
                                        <td class="kh-td" data-label="Item / Location">
                                            <input v-model="item.location" class="kh-input kh-input-cell" />
                                        </td>
                                        <td class="kh-td kh-td-center" data-label="Key No.">
                                            <input v-model="item.number" class="kh-input kh-input-cell" />
                                        </td>
                                        <td class="kh-td kh-td-center" data-label="Total">
                                            <input v-model="item.total" class="kh-input kh-input-cell" type="number" min="0" />
                                        </td>
                                        <td class="kh-td kh-td-center kh-td-action">
                                            <button type="button" class="kh-remove-btn" @click="removeHandoverItem(index)" title="Remove">&#215; Remove</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else class="kh-empty">No items added yet. Fill in the form above and tap Add.</div>
                    </div>
                </div>

                <!-- ── Section: Notes ── -->
                <div class="kh-card">
                    <div class="kh-card-header">
                        <span>&#128221;</span> Notes
                    </div>
                    <div class="kh-card-body">
                        <textarea v-model="form.notes" class="kh-input kh-textarea" rows="3" placeholder="Additional notes or remarks..."></textarea>
                    </div>
                </div>

                <!-- Bottom actions -->
                <div class="kh-footer-actions">
                    <router-link class="kh-btn kh-btn-ghost" :to="{ name: 'inventory-add', query: { propertyId: property_id } }">&#8592; Back</router-link>
                    <div class="kh-footer-right">
                        <button type="button" class="kh-btn kh-btn-success" v-if="handoverData && handoverData.id" @click="exportPDF">&#11015; Download PDF</button>
                        <button type="submit" class="kh-btn kh-btn-primary">&#10003; Save</button>
                    </div>
                </div>

            </form>
        </div>

        <!-- Image preview lightbox -->
        <div class="kh-lightbox" v-if="previewImage" @click="closeImagePreview">
            <button type="button" class="kh-lightbox-close" @click="closeImagePreview" title="Close">&#215;</button>
            <img :src="previewImage" class="kh-lightbox-img" @click.stop />
        </div>
    </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormTextarea, BFormRating, BFormCheckbox,BFormCheckboxGroup,
  BTab, BTabs, BInputGroup, BBadge, BCard, BContainer, BFormDatepicker, BFormFile, BTable,
} from 'bootstrap-vue'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import html2pdf from 'html2pdf.js';

export default {
  components: {
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormTextarea, BFormRating,
    BFormCheckbox, BFormCheckboxGroup, BTab, BTabs, BInputGroup, BBadge, BCard, BCardActions,
    BContainer, BFormDatepicker, BFormFile, BTable,
  },
    data() {
        const userStorage = JSON.parse(localStorage.getItem('userData'))
        const property_id = router.currentRoute.params.id

        return {
            form: {
                propertyId: router.currentRoute.params.id,
                lessor: '',
                lessee: '',
                date: '',
                notes: '',
                electricity: {
                    arrivalRecord: '',
                    arrivalDate: '',
                    arrivalImage: '',
                    departureRecord: '',
                    departureDate: '',
                    departureImage: '',
                },
                water: {
                    arrivalRecord: '',
                    arrivalDate: '',
                    arrivalImage: '',
                    departureRecord: '',
                    departureDate: '',
                    departureImage: '',
                },
                handoverItemsImage: '',
                handoverItems: [
                    { location: 'Main door entrance', number: '', total: '' },
                    { location: 'Master Bedroom', number: '', total: '' },
                    { location: 'Second Bedroom', number: '', total: '' },
                    { location: 'Third Bedroom', number: '', total: '' },
                    { location: 'Maid Room', number: '', total: '' },
                    { location: 'Key card', number: '', total: '' },
                    { location: 'Mail box', number: '', total: '' },
                    { location: 'Parking Sticker', number: '', total: '' },
                ],
                created_by: userStorage.id,
                updated_by: userStorage.id
            },
            newItem: {
                location: '',
                number: '',
                total: ''
            },
            itemCounter: 1,
            tableFields: [
                { key: 'location', label: 'Item/Location' },
                { key: 'number', label: 'Key No.' },
                { key: 'total', label: 'Total' },
                { key: 'actions', label: 'Actions' }
            ],
            handoverData: [],
            property_id: property_id,
            propertyData: [],
            preparingPDF: false,
            dragIndex: null,
            dragOverIndex: null,
            previewImage: null,
        }
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale
        },
    },
    methods: {
        addHandoverItem() {
            const { location, number, total } = this.newItem
            // if (!location || !number || !total) {
            //     alert('Please fill all handover item fields')
            //     return
            // }

            this.form.handoverItems.push({
                location,
                number,
                total
            })

            this.newItem = {
                location: '',
                number: '',
                total: ''
            }
        },
        removeHandoverItem(index) {
            this.form.handoverItems.splice(index, 1)
        },
        onDragStart(index, event) {
            this.dragIndex = index
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('text/plain', String(index))
        },
        onDragOver(index, event) {
            event.preventDefault()
            event.dataTransfer.dropEffect = 'move'
            this.dragOverIndex = index
        },
        onDrop(index, event) {
            event.preventDefault()
            if (this.dragIndex === null || this.dragIndex === index) return

            const items = this.form.handoverItems
            const [moved] = items.splice(this.dragIndex, 1)
            items.splice(index, 0, moved)

            this.dragIndex = null
            this.dragOverIndex = null
        },
        onDragEnd() {
            this.dragIndex = null
            this.dragOverIndex = null
        },
        resizeMeterImage(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()

                reader.onload = (event) => {
                    const img = new Image()
                    img.onload = () => {
                        const maxWidth = 1040
                        const maxHeight = 1040
                        let width = img.width
                        let height = img.height

                        if (width > height && width > maxWidth) {
                            height *= maxWidth / width
                            width = maxWidth
                        } else if (height > width && height > maxHeight) {
                            width *= maxHeight / height
                            height = maxHeight
                        }

                        const canvas = document.createElement('canvas')
                        canvas.width = width
                        canvas.height = height
                        canvas.getContext('2d').drawImage(img, 0, 0, width, height)

                        canvas.toBlob(blob => resolve(blob), file.type || 'image/jpeg', 0.9)
                    }
                    img.onerror = () => reject('Failed to load image.')
                    img.src = event.target.result
                }
                reader.onerror = () => reject('Failed to read file.')
                reader.readAsDataURL(file)
            })
        },
        async onMeterImageChange(event, meterType, phase) {
            const file = event.target.files && event.target.files[0]
            if (!file) return

            const imageKey = `${phase}Image`

            try {
                const resizedImage = await this.resizeMeterImage(file)

                const formData = new FormData()
                formData.append('image', resizedImage)

                const response = await axios.post('/property/v1/inventory/uploadImages', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                })

                const uploaded = response.data.data
                this.form[meterType][imageKey] = Array.isArray(uploaded) ? uploaded[0] : uploaded
            } catch (error) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: 'Failed to upload photo.',
                    },
                });
            }

            event.target.value = ''
        },
        removeMeterImage(meterType, phase) {
            const imageKey = `${phase}Image`
            const removed = this.form[meterType][imageKey]
            this.form[meterType][imageKey] = ''
            axios.post('/property/v1/inventory/removeImage', { removeImage: [removed] }).catch(() => {})
        },
        async onHandoverItemsImageChange(event) {
            const file = event.target.files && event.target.files[0]
            if (!file) return

            try {
                const resizedImage = await this.resizeMeterImage(file)

                const formData = new FormData()
                formData.append('image', resizedImage)

                const response = await axios.post('/property/v1/inventory/uploadImages', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                })

                const uploaded = response.data.data
                this.form.handoverItemsImage = Array.isArray(uploaded) ? uploaded[0] : uploaded
            } catch (error) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: 'Failed to upload photo.',
                    },
                });
            }

            event.target.value = ''
        },
        removeHandoverItemsImage() {
            const removed = this.form.handoverItemsImage
            this.form.handoverItemsImage = ''
            axios.post('/property/v1/inventory/removeImage', { removeImage: [removed] }).catch(() => {})
        },
        openImagePreview(url) {
            this.previewImage = url
        },
        closeImagePreview() {
            this.previewImage = null
        },
        async submitForm() {
            try {
                if(this.handoverData && this.handoverData.id){
                    const response = await axios.post('/handover/v1/update', this.form);
                    if (response.data.success) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Success',
                                icon: 'BellIcon',
                                variant: 'success',
                                text: response.data.message,
                            },
                        });

                        this.fetchingKeyHand()
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Error',
                                icon: 'BellIcon',
                                variant: 'danger',
                                text: response.data.message || 'Failed to add the handover.',
                            },
                        });
                    }
                } else {
                    const response = await axios.post('/handover/v1/add', this.form);
                    if (response.data.success) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Success',
                                icon: 'BellIcon',
                                variant: 'success',
                                text: response.data.message,
                            },
                        });

                        this.fetchingKeyHand()
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Error',
                                icon: 'BellIcon',
                                variant: 'danger',
                                text: response.data.message || 'Failed to add the handover.',
                            },
                        });
                    }
                }
            } catch (error) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: error.response?.data?.message || 'There was a problem adding the handover.',
                    },
                });
            }
        },
        async fetchingKeyHand(){
            try {
                const response = await axios.get(`/handover/v1/get/${this.property_id}`);
                if (response.data.success) {
                    const d = response?.data?.data[0] || {}
                    this.handoverData = d
                    this.form = {
                        ...this.form,
                        ...d,
                        handoverItemsImage: d.handoverItemsImage ?? '',
                        handoverItems: (d.handoverItems && d.handoverItems.length ? d.handoverItems : this.form.handoverItems).map(item => ({
                            location: item.location ?? '',
                            number: item.number ?? '',
                            total: item.total ?? '',
                        })),
                        electricity: {
                            arrivalRecord:   d.electricity?.arrivalRecord   ?? '',
                            arrivalDate:     d.electricity?.arrivalDate     ?? '',
                            arrivalImage:    d.electricity?.arrivalImage    ?? '',
                            departureRecord: d.electricity?.departureRecord ?? '',
                            departureDate:   d.electricity?.departureDate   ?? '',
                            departureImage:  d.electricity?.departureImage  ?? '',
                        },
                        water: {
                            arrivalRecord:   d.water?.arrivalRecord   ?? '',
                            arrivalDate:     d.water?.arrivalDate     ?? '',
                            arrivalImage:    d.water?.arrivalImage    ?? '',
                            departureRecord: d.water?.departureRecord ?? '',
                            departureDate:   d.water?.departureDate   ?? '',
                            departureImage:  d.water?.departureImage  ?? '',
                        },
                    };
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Error',
                            icon: 'BellIcon',
                            variant: 'danger',
                            text: response.data.message || 'Failed to fetch the handover.',
                        },
                    });
                }
            } catch(error) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: error.response?.data?.message || 'Something went wrong.',
                    },
                });
            }
        },
        async fetchingPropertyData(){
            try {
                const response = await axios.post(`/cache-master/v1/property-filter`, {
                    perpage: 10,
                    offset: 0,
                    byID: this.property_id
                });
                if (response.data.success) {
                    this.propertyData = response?.data?.data[0]
                } else {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: 'Error',
                            icon: 'BellIcon',
                            variant: 'danger',
                            text: response.data.message || 'Failed to fetch the handover.',
                        },
                    });
                }
            } catch(error) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: error.response?.data?.message || 'Something went wrong.',
                    },
                });
            }
        },
        async exportPDF() {
            if (
                !this.form.lessor ||
                !this.form.lessee ||
                !this.form.date ||
                this.form.handoverItems.length === 0
            ) {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Form Incomplete',
                        icon: 'AlertTriangleIcon',
                        variant: 'warning',
                        text: 'Please fill in all required fields before downloading the PDF.',
                    },
                });
                return;
            }

            this.preparingPDF = true;
            await this.$nextTick();

            const element = this.$refs.pdfContent;

            const opt = {
                margin: 0.5,
                filename: 'key-handover.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
                pagebreak: { mode: ['avoid-all'] },
            };

            await html2pdf().from(element).set(opt).save();

            this.preparingPDF = false;
        },
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);

            const day = d.getDate();
            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];
            const month = monthNames[d.getMonth()];
            const year = d.getFullYear();

            return `${day} ${month} ${year}`;
        },
        formatDateTime(date) {
            if (!date) return '';
            const d = new Date(date);

            return `${this.formatDate(d)} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
        },
    },
    async created(){
        await this.fetchingKeyHand()
        this.fetchingPropertyData()
        if (this.$route.query.autoDownload === 'true' && this.handoverData && this.handoverData.id) {
            await this.$nextTick()
            this.exportPDF()
        }
    }
}
</script>

<style scoped>
/* ── Page ── */
.kh-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  color: #5e5873;
  background: #f8f8f8;
  min-height: 100vh;
  padding: 20px 16px;
  max-width: 1000px;
  margin: 0 auto;
}

/* ── Top bar ── */
.kh-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #80AC03;
  color: #fff;
  padding: 12px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}
.kh-topbar-left { display: flex; align-items: center; gap: 10px; }
.kh-topbar-icon { font-size: 18px; }
.kh-topbar-title { font-size: 16px; font-weight: 700; letter-spacing: 0.3px; }
.kh-topbar-actions { display: flex; gap: 8px; flex-wrap: wrap; }

/* ── Buttons ── */
.kh-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.15s, box-shadow 0.15s;
}
.kh-btn:hover { opacity: 0.88; }
.kh-btn-primary { background: #80AC03; color: #fff; }
.kh-btn-success { background: #28c76f; color: #fff; }
.kh-btn-outline { background: transparent; color: #fff; border: 1px solid rgba(255,255,255,0.55); }
.kh-btn-ghost   { background: transparent; color: #80AC03; border: 1px solid #80AC03; }

/* ── Cards ── */
.kh-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #ebe9f1;
  overflow: hidden;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(128,172,3,0.06);
}
.kh-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f4f8e6;
  border-bottom: 1px solid #ebe9f1;
  padding: 12px 18px;
  font-size: 13px;
  font-weight: 700;
  color: #80AC03;
  letter-spacing: 0.2px;
}
.kh-card-header-warning { background: #fff8f0; color: #ff9f43; border-bottom-color: #ffecd2; }
.kh-card-header-info    { background: #f0fbff; color: #00cfe8; border-bottom-color: #c9f1f8; }
.kh-card-body { padding: 18px; }

/* ── Grids ── */
.kh-grid-3 { display: flex; gap: 16px; flex-wrap: wrap; }
.kh-grid-3 .kh-field { flex: 1; min-width: 180px; }
.kh-grid-2-cols { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
@media (max-width: 680px) { .kh-grid-2-cols { grid-template-columns: 1fr; } }

/* ── Fields ── */
.kh-field { margin-bottom: 12px; }
.kh-field-inline { flex: 1; min-width: 120px; }
.kh-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 5px;
}
.kh-required { color: #ea5455; }
.kh-optional { color: #b9b9c3; font-weight: 400; font-size: 11px; margin-left: 4px; }
.kh-last-updated { display: block; margin-top: 5px; color: #b9b9c3; font-size: 11px; }
.kh-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d8d6de;
  border-radius: 6px;
  font-size: 13px;
  color: #5e5873;
  background: #fff;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  box-sizing: border-box;
  font-family: inherit;
}
.kh-input:focus { border-color: #80AC03; box-shadow: 0 0 0 3px rgba(128,172,3,0.15); }
.kh-textarea { resize: vertical; min-height: 90px; }

/* ── Meter sections ── */
.kh-meter-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 0;
}
.kh-meter-section + .kh-meter-section {
  border-top: 1px solid #f1f0f5;
}
.kh-meter-label {
  display: flex;
  align-items: center;
  gap: 6px;
}
.kh-meter-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.kh-dot-in  { background: #28c76f; }
.kh-dot-out { background: #ea5455; }
.kh-meter-label-text {
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.kh-text-in  { color: #28c76f; }
.kh-text-out { color: #ea5455; }
.kh-meter-fields {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

/* ── Meter photo ── */
.kh-photo-input { display: none; }
.kh-photo-field { flex: 0 0 auto; }
.kh-label-hidden { visibility: hidden; }
.kh-photo-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid #d8d6de;
  border-radius: 6px;
  background: #fff;
  color: #80AC03;
  cursor: pointer;
  font-size: 16px;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.kh-photo-icon-btn:hover { border-color: #80AC03; box-shadow: 0 0 0 3px rgba(128,172,3,0.15); }
.kh-photo-thumb {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 38px;
}
.kh-photo-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  cursor: zoom-in;
  border-radius: 6px;
  border: 1px solid #ebe9f1;
}
.kh-photo-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  background: rgba(0,0,0,0.6);
  color: #fff;
  font-size: 10px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.kh-photo-remove:hover { background: #ea5455; }

/* ── Shared handover items photo ── */
.kh-items-photo-field { margin-bottom: 14px; }
.kh-photo-thumb-lg { width: 90px; height: 90px; }
.kh-photo-icon-btn-lg { width: 90px; height: 90px; font-size: 28px; }

/* ── Handover add form ── */
.kh-add-form {
  padding: 14px;
  background: #f4f8e6;
  border-radius: 8px;
  border: 1px dashed #c5bef5;
  margin-bottom: 14px;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}
.kh-add-location { display: flex; flex-direction: column; flex: 2; min-width: 200px; }
.kh-add-sub { display: flex; flex-direction: column; flex: 1; min-width: 100px; }
.kh-add-btn { flex-shrink: 0; padding: 8px 20px; }

/* ── Table ── */
.kh-table-wrap { overflow-x: auto; }
.kh-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.kh-th {
  background: #80AC03;
  color: #fff;
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.3px;
}
.kh-td {
  padding: 10px 12px;
  border-bottom: 1px solid #ebe9f1;
  color: #5e5873;
  vertical-align: middle;
}
.kh-td-center { text-align: center; }
.kh-input-cell { min-width: 90px; padding: 6px 10px; font-size: 13px; }
.kh-tr-stripe { background: #f4f8e6; }
.kh-remove-btn {
  background: none;
  border: 1px solid #ea5455;
  color: #ea5455;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
  padding: 4px 10px;
  white-space: nowrap;
}
.kh-remove-btn:hover { background: #ea5455; color: #fff; }

.kh-td-drag { width: 30px; padding: 10px 4px; }
.kh-drag-handle {
  display: inline-flex;
  cursor: grab;
  color: #b9b9c3;
  font-size: 13px;
  letter-spacing: -2px;
  user-select: none;
  padding: 4px;
}
.kh-drag-handle:active { cursor: grabbing; }
.kh-table tbody tr[draggable="true"] { cursor: grab; }
.kh-tr-dragging { opacity: 0.4; }
.kh-tr-dragover { box-shadow: inset 0 2px 0 #80AC03; }

/* ── Count badge ── */
.kh-count-badge {
  background: #80AC03;
  color: #fff;
  font-size: 11px;
  border-radius: 10px;
  padding: 1px 8px;
  margin-left: 4px;
}

/* ── Empty state ── */
.kh-empty {
  text-align: center;
  padding: 20px;
  color: #b9b9c3;
  font-size: 13px;
  font-style: italic;
}

/* ── Footer actions ── */
.kh-footer-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
  flex-wrap: wrap;
  gap: 10px;
}
.kh-footer-right { display: flex; gap: 10px; }

/* ── Mobile ── */
@media (max-width: 576px) {

  /* Page */
  .kh-page { padding: 12px 10px; }

  /* Topbar */
  .kh-topbar {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 14px;
    border-radius: 8px;
    gap: 10px;
  }
  .kh-topbar-actions {
    width: 100%;
    flex-wrap: wrap;
    gap: 6px;
  }
  .kh-topbar-actions .kh-btn {
    flex: 1;
    justify-content: center;
    min-width: 100px;
  }

  /* Cards */
  .kh-card-body { padding: 14px; }
  .kh-grid-2-cols { grid-template-columns: 1fr; }
  .kh-grid-3 { flex-direction: column; gap: 0; }

  /* Meter sections */
  .kh-field-inline { width: 100%; min-width: 0; }

  /* Add form — stack fields on mobile, button full width */
  .kh-add-form { flex-direction: column; align-items: stretch; }
  .kh-add-location, .kh-add-sub { min-width: 0; }
  .kh-add-btn {
    width: 100%;
    justify-content: center;
    margin-top: 2px;
  }

  /* Table → card list on mobile */
  .kh-table-wrap { overflow-x: visible; }
  .kh-table thead { display: none; }
  .kh-table, .kh-table tbody, .kh-table tr, .kh-table td { display: block; width: 100%; }
  .kh-table tr {
    background: #fff;
    border: 1px solid #ebe9f1;
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(128,172,3,0.06);
  }
  .kh-tr-stripe { background: #fff; }
  .kh-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    border-bottom: 1px solid #f3f2ff;
    text-align: right;
  }
  .kh-table td:last-child { border-bottom: none; }
  .kh-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #80AC03;
    font-size: 12px;
    text-align: left;
    flex-shrink: 0;
  }
  /* Hide the drag handle and # columns on mobile (native drag-and-drop isn't usable on touch; order is redundant with card order) */
  .kh-table td:nth-child(-n+2) { display: none; }
  /* Action cell — remove button full width */
  .kh-td-action {
    justify-content: center;
    padding: 10px 14px;
  }
  .kh-td-action::before { display: none; }
  .kh-remove-btn { width: 100%; justify-content: center; padding: 8px; }

  /* Footer — full-width stacked buttons */
  .kh-footer-actions {
    flex-direction: column-reverse;
    gap: 8px;
  }
  .kh-footer-right {
    width: 100%;
    flex-direction: column-reverse;
    gap: 8px;
  }
  .kh-footer-right .kh-btn,
  .kh-footer-actions > .kh-btn {
    width: 100%;
    justify-content: center;
    padding: 12px;
    font-size: 14px;
  }
}

/* ── Image preview lightbox ── */
.kh-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 40px;
  cursor: zoom-out;
}
.kh-lightbox-img {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.5);
  cursor: default;
}
.kh-lightbox-close {
  position: absolute;
  top: 20px;
  right: 24px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.15);
  color: #fff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background 0.15s;
}
.kh-lightbox-close:hover { background: rgba(255,255,255,0.3); }
</style>